import { Container, Dialog, DialogContent, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon,
    Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import Success from '../../components/Form/Success';
import TextField from "../../components/Form/TextField";
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { ConciergeSearch } from '../../interfaces/Concierge';
import ConciergeApi from '../../services/MvmApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import utilsDate from '../../utils/Date';
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import ConciergeForm from './ConciergeForm';
import { DialogTitle, PaperComponent, useStyles } from './Style';

const opcoes = [
    { url: '/concierge', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/concierge', descricao: 'Pesquisar', state: {}}
]

interface Params {
    openPanelOnLoad: boolean;
}

const Concierge: React.FC = () => {
    const classes = useStyles();
    const location = useLocation<Params>();
    const [concierges, setConcierges] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [openedPainel, setOpenedPainel] = React.useState(false);
    const [conciergeId, setConciergeId] = useState<number>(0);
    const { user, hasPermission } = useAuth();
    const { t } = useTranslation("Concierge");
    const { t: _t } = useTranslation("General");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const { handleSubmit, reset, getValues , control } = useForm<ConciergeSearch>(
        {
            defaultValues: { code: '' }
        });
    const [success, setSuccess] = useState(false);
    
    useEffect(() => {
        if (!hasPermission(permissions.CONCIERGE.Search))
            history.replace('NoPermission');
        
    }, [history, user])

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'deleted',
            options: {
                display: false,
            }
        },
        {
            name: 'code',
            label: String(t('code')),   
            options: {
                setCellProps: () => ({                       
                    align: "left",
                }),
            }
        },
        {
            name: 'descriptionHosts',
            label: String(t('descriptionHosts')),
            
            options: {
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'updatedBy',
            label: String(t('updatedBy')),
            options: {
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'updatedAt',
            label: String(t('updatedAt')),
            options: {
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTime(value);
                }
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0])
                )
            }
        },
    ]

    const renderButtons = (id: any) => {
        return (
            <AlertDialog
                dialogTitle={t("dialogDeleteTitle")}
                dialogContentText={t("dialogDeleteContentText")}
                cancelTextButton={t("cancelDeleteTextButton")}
                confirmTextButton={t("confirmDeleteTextButton")}
                confirmDialogFunction={() => { handleDeleteItem(id); }}
                Button={
                    <IconButton size='small' edge="end" disabled={!hasPermission(permissions.CONCIERGE.Delete)}>
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    }

    function handleDeleteItem(id: number) {
        setLoading(true);
        ConciergeApi.deleteConcierge(id)
        .then(result => {
            enqueueSnackbar(t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
        }).finally(() => {
            onSubmit(getValues());
        });
    };

    useKeypress('Escape', () => {
        setOpenedPainel(false);
    });

    useEffect(() => {
        var data = getValues()
        onSubmit(data)
        //var emBase64 = btoa("http://uol.com.br");
        //alert(emBase64);
        //var deBase64 = atob("WiFxRTk4S0tHJF5cbmJfVyRmaCM=")
        //alert(deBase64);
    }, [user]);

    
    const onSubmit = useCallback(
        async (data: ConciergeSearch) => {
            setLoading(true);
            data.pageSize = 1000;
            data.plantId = Number(user.company.plantID);
            ConciergeApi.searchConcierge(data)
                .then(result => {
                    if (result && result.items) {
                        setConcierges(result);
                    }
                    else {
                        setConcierges([]);
                    }
                }).catch(() => {
                    setConcierges([]);
                }).finally(() => {
                    setLoading(false);
                });
        },
        [user],
    );

    const handleOpenPanelChange = (id: any) => {
        setConciergeId(id);
        setOpenedPainel(true);
    };

    const callbackDialogHandle = () => {
        setOpenedPainel(false);
        onSubmit(getValues());
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: concierges?.items ? 'pointer' : ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    useEffect(() => {
        if (location.state?.openPanelOnLoad)
        {
            setConciergeId(0)
            setOpenedPainel(true); 
            
        }
    }, [location.state?.openPanelOnLoad, user])
    
    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <Dialog
                open={openedPainel}
                aria-labelledby="form-dialog-title"
                PaperComponent={PaperComponent}
                onBackdropClick={() => setOpenedPainel(false)}
                fullWidth>

                <DialogTitle classes={{ root: classes.dialogTitle }}
                    id="draggable-dialog-title"
                    onClose={() => setOpenedPainel(false)}>
                    {conciergeId !== 0 ? t("editTitle") : t("addTitle")}
                </DialogTitle>

                <DialogContent>
                    <ConciergeForm conciergeId={conciergeId} handleSetSuccess={setSuccess} clickHandlerCallback={callbackDialogHandle} clickHandlerClose={() => setOpenedPainel(false)} />
                </DialogContent>

            </Dialog>

            <PageTitle title={t("concierge")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>
                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI disabled={!hasPermission(permissions.CONCIERGE.Add)} color="secondary" onClick={() => { setOpenedPainel(true); setConciergeId(0) }} startIcon={<AddIcon />}>{t("add")}</ButtonUI>
                                <ButtonUI onClick={() => reset() } startIcon={<BackspaceOutlinedIcon />}>{t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <TextField label={t("code")} name="code" control={control} fullWidth inputProps={{maxLength: 4}} />
                            </Grid>
                        </Grid>
                    </form>
                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={concierges?.items}
                                    columns={columns} 
                                       
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: false,
                                        pagination: concierges?.items ? true : false,
                                        sort: concierges?.items ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        onCellClick: (_colData, { colIndex, dataIndex }) => {
                                            if (hasPermission(permissions.CONCIERGE.Edit))
                                                if ((concierges?.items) && colIndex < 6) {
                                                    handleOpenPanelChange(concierges.items[dataIndex].id);
                                                }
                                        },
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default Concierge;
